import React from 'react'
import Image from 'next/image'
import { defaultLoader } from '../utils/custom-image-loader'

interface ContainerProps {
  nestedImageUrl: String
  nestedImageText: String
  dynamicMediaUrl?: string
}

const NestedImage: React.FC<ContainerProps> = (props) => {
  const dynamicMediaUrl = props.dynamicMediaUrl || props.nestedImageUrl.toString()
  return (
    <div className="nestedimage">
        <div className="nestedimage__img image-next">
          <Image src={dynamicMediaUrl} tabIndex={0} className="nestedimage__image" alt="Content Page Nested Image" fill loader={defaultLoader}/>
        </div>
        <div className="nestedimage__txt">
            <p>{props.nestedImageText}</p>
        </div>
    </div>
  )
}

export default NestedImage
